import fetch from "auth/FetchInterceptor";

const AuthService = {};

// `portal: 'merchant'` tells the backend to gate the OTP flow to merchant
// portal users (users.local_partner or is_admin). With the flag the backend
// returns 404 for unknown emails and 403 { code: 'NOT_MERCHANT_PORTAL_USER' }
// for accounts without portal access — on both sendOTP and signIn.
AuthService.sendOTP = function (data) {
  return fetch({
    url: "/v1/user/sendOTPViaEmail",
    method: "post",
    data: { ...data, portal: "merchant" },
  });
};

AuthService.signInWithOTP = function (data) {
  return fetch({
    url: "/v1/user/signInWithOTPViaEmail",
    method: "post",
    data: { ...data, portal: "merchant" },
  });
};

export default AuthService;
